export default "__VITE_ASSET__mv4FcmiI__"